const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
const seen = new WeakSet();
let observer;

const selectors = [
  'main .media-with-content__content',
  'main .section-resource-list__content',
  'main .text-block.h2',
  'main .shopify-section h2',
  'main .shopify-section h3',
].join(',');

function enhance(root = document) {
  if (preference.matches || document.documentElement.classList.contains('shopify-design-mode')) return;
  document.documentElement.classList.add('doriante-motion-enabled');
  if (!('IntersectionObserver' in window)) return;

  observer ??= new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      seen.add(entry.target);
      entry.target.classList.add('doriante-arrive');
      observer.unobserve(entry.target);
    }
  }, { threshold: 0.12, rootMargin: '0px 0px -24px 0px' });

  const targets = Array.from(root.querySelectorAll(selectors)).filter((target) =>
    !target.closest('dialog, product-card, collection-card, product-form-component, sticky-add-to-cart')
  );
  for (const target of targets) {
    // Animate a content group once, without animating its children again.
    if (targets.some((parent) => parent !== target && parent.contains(target))) continue;
    if (seen.has(target)) continue;
    observer.observe(target);
  }
}

preference.addEventListener('change', () => {
  if (preference.matches) {
    observer?.disconnect();
    observer = undefined;
    document.documentElement.classList.remove('doriante-motion-enabled');
  } else {
    enhance();
  }
});

document.addEventListener('shopify:section:load', (event) => enhance(event.target));
enhance();
